import { useFormat } from 'vivat';
import useCashFlowStatus from '@/useCashFlowStatus';

const { translate, cashFlowStatusClassMap } = useCashFlowStatus();

export const _primaryControls = {
  width: '3rem',
};

export const _selectorControls = {
  width: '2rem',
};

export const _increment = {
  name: 'ลำดับ',
  width: '3rem',
  class: 'text-center',
};

export const status = {
  name: 'สถานะ',
  width: '8rem',
  class: {
    text(val: string, row: { item: { [key: string]: any }; index: number }) {
      return cashFlowStatusClassMap(val, row.item.date);
    },
    cell: 'text-center',
  },
  filter(val: string, row: { item: { [key: string]: any }; index: number }) {
    return translate(val, row.item.date);
  },
};

export const createdAt = {
  name: 'สร้างเมื่อ',
  width: '12rem',
  filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
};

export const name = {
  name: 'รายการ',
  width: '1fr',
};

export const amount = {
  name: 'รายจ่าย',
  width: '10rem',
  class: 'text-right',
};

export const createdBy = {
  name: 'ผู้ทำรายการ',
  width: '10rem',
  class: 'text-right',
};

export const sortable = [
  // 'status',
  'createdAt',
  'payment_account_id',
  'name',
  'type',
  // 'income',
  'amount',
  'createdBy',
];
